import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
function escapeHtml(value) {
    return value.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
}
function escapeRegex(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
/** Monta o HTML da mensagem como a tela antiga: HTML ou texto, com as imagens cid: trocadas pelo base64 dos anexos. */
export function buildMailHtml(html, text, files) {
    let content = html ? html : `<p style="white-space:pre-wrap">${escapeHtml(text || '')}</p>`;
    files.forEach((file) => {
        if (!file.cid || !file.base64)
            return;
        const cid = file.cid.replace(/^<|>$/g, '');
        content = content.replace(new RegExp(`src=(["'])cid:<?${escapeRegex(cid)}>?\\1`, 'g'), `src="${file.base64}"`);
    });
    return content;
}
/**
 * Mostra o corpo do e-mail isolado num iframe com sandbox (sem scripts, sem formulários),
 * para o HTML externo não mexer na página do painel. Links abrem em nova aba.
 */
export function MailBody({ html, title }) {
    const ref = React.useRef(null);
    const [height, setHeight] = React.useState(200);
    const doc = React.useMemo(() => `<!doctype html><html><head><meta charset="utf-8">` +
        `<meta http-equiv="Content-Security-Policy" content="script-src 'none'; object-src 'none'; form-action 'none'; base-uri 'none'">` +
        `<base target="_blank">` +
        `<style>html,body{margin:0;padding:0;background:#fff;color:#1e1e1e;font-family:system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;font-size:14px;line-height:1.6;word-break:break-word}body{padding:16px}img{max-width:100%;height:auto}table{max-width:100%}pre{white-space:pre-wrap}</style>` +
        `</head><body>${html}</body></html>`, [html]);
    React.useEffect(() => {
        const frame = ref.current;
        if (!frame)
            return;
        let observer = null;
        const measure = () => {
            const d = frame.contentDocument;
            if (!d || !d.documentElement)
                return;
            setHeight(Math.max(120, Math.ceil(d.documentElement.scrollHeight)));
        };
        const onLoad = () => {
            var _a, _b;
            measure();
            const body = (_a = frame.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
            if (body && typeof ResizeObserver !== 'undefined') {
                observer === null || observer === void 0 ? void 0 : observer.disconnect();
                observer = new ResizeObserver(measure);
                observer.observe(body);
            }
            // Imagens remotas podem terminar de carregar depois.
            (_b = frame.contentDocument) === null || _b === void 0 ? void 0 : _b.querySelectorAll('img').forEach((img) => img.addEventListener('load', measure));
        };
        frame.addEventListener('load', onLoad);
        return () => {
            frame.removeEventListener('load', onLoad);
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [doc]);
    return (_jsx("iframe", { ref: ref, title: title, srcDoc: doc, 
        // Sem allow-scripts: nenhum script do e-mail roda. allow-same-origin só para medir a altura do conteúdo.
        sandbox: "allow-same-origin allow-popups allow-popups-to-escape-sandbox", referrerPolicy: "no-referrer", className: "block w-full rounded-lg border bg-white", style: { height } }));
}
